import { createSlice } from "@reduxjs/toolkit";

const resetCareerMonster = {
  total: 0,
  tableResponse: null,
  fullResponse: null,
  existingCandidates: null,
};

export const internalDbESSlice = createSlice({
  name: "internaldbesslice",
  initialState: {
    loading: false,
    error: null,

    // Internal DB
    totalApplicantsCount: 0,
    totalApplicantsData: null,
    totalRecords: 0,

    // Career Builder
    careerBuilder: {
      total: 0,
      tableResponse: null,
      fullResponse: null,
      existingCandidates: null,
    },

    // Monster
    monster: {
      total: 0,
      tableResponse: null,
      fullResponse: null,
      existingCandidates: null,
    },
    bulkResumesData: {
      data: [],
    },
    careerBuilderBulkResumesData: {
      data: [],
    },
    accessData: {
      careerBuilder: null,
      monster: null,
      allapplicant: null,
    },
  },
  reducers: {
    // Loading
    setStateLoading(state) {
      state.loading = true;
    },
    revertStateLoading(state) {
      state.loading = false;
    },

    getAllApplicantsDataStart(state) {
      state.loading = true;
    },
    getAllApplicantsDataSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.totalApplicantsCount = action.payload?.field?.data?.total ?? 0;
      state.totalApplicantsData = action.payload?.field?.data?.candidates ?? [];
      state.totalRecords = action.payload?.field?.data?.totalRecords ?? 0;
    },
    getAllApplicantsDataFailure(state, action) {
      state.loading = false;
      state.error = "error";
    },

    // Career Builder
    getCareerBuilderApplicantsDataStart(state) {
      state.loading = true;
    },
    getCareerBuilderApplicantsDataSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.careerBuilder.total = action.payload?.result?.total ?? 0;
      state.careerBuilder.tableResponse =
        action.payload?.result?.tableResponse ?? [];
      state.careerBuilder.fullResponse =
        action.payload?.result?.fullResponse ?? [];
      state.careerBuilder.existingCandidates =
        action.payload?.existingCandidates ?? [];
    },
    getCareerBuilderApplicantsDataFailure(state, action) {
      state.loading = false;
      state.error = "error";
    },
    updateCareerBuilderApplicantsDataStart(state) {
      state.loading = true;
    },
    updateCareerBuilderApplicantsDataSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.careerBuilder.tableResponse =
        action.payload?.updatedTableResponse ?? [];
      state.careerBuilder.fullResponse =
        action.payload?.updatedFullResponse ?? [];
      state.careerBuilder.existingCandidates =
        action.payload?.updatedExistingCandidates ?? [];
    },
    updateCareerBuilderApplicantsDataFailure(state, action) {
      state.loading = false;
    },

    // Monster
    getMonsterApplicantsDataStart(state) {
      state.loading = true;
    },
    getMonsterApplicantsDataSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.monster.total = action.payload.result.total ?? 0;
      state.monster.tableResponse = action.payload?.result?.tableResponse ?? [];
      state.monster.fullResponse = action.payload?.result?.fullResponse ?? [];
      state.monster.existingCandidates =
        action.payload?.existingCandidates ?? [];
    },
    getMonsterApplicantsDataFailure(state) {
      state.loading = false;
      state.error = "error";
    },

    updateMonsterApplicantsDataStart(state) {
      state.loading = true;
    },
    updateMonsterApplicantsDataSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.monster.tableResponse = action.payload?.updatedTableResponse ?? [];
      state.monster.fullResponse = action.payload?.updatedFullResponse ?? [];
      state.monster.existingCandidates =
        action.payload?.updatedExistingCandidates ?? [];
    },
    updateMonsterApplicantsDataFailure(state, action) {
      state.loading = false;
      state.error = "error";
    },

    // Integrated Search
    getIntegratedSearchStart(state) {
      state.loading = true;
    },
    fetchBulkResumesDataStart(state) {
      state.loading = true;
    },
    fetchBulkResumesSuccess(state, action) {
      state.bulkResumesData.data = action.payload.data;
      state.loading = false;
    },
    fetchBulkResumesFailure(state) {
      state.loading = false;
      state.error = "error";
    },
    fetchCBBulkResumesDataStart(state) {
      state.loading = true;
    },
    fetchCBBulkResumesSuccess(state, action) {
      state.careerBuilderBulkResumesData.data = action.payload.data;
      state.loading = false;
    },
    fetchCBBulkResumesFailure(state) {
      state.loading = false;
      state.error = "error";
    },
    setcareerBuilderAccessidStart(state) {
      state.loading = true;
    },
    setcareerBuilderAccessidSuccess(state, action) {
      state.loading = false;
      state.accessData.careerBuilder = action.payload.data;
    },
    setcareerBuilderAccessidFailure(state) {
      state.loading = false;
      state.error = "AccessID error";
    },
    setMonsterAccessidStart(state) {
      state.loading = true;
    },
    setMonsterAccessidSuccess(state, action) {
      state.loading = false;
      state.accessData.monster = action.payload.data;
    },
    setMonsterAccessidFailure(state) {
      state.loading = false;
      state.error = "AccessID error";
    },
    setAllApplicantAccessidStart(state) {
      state.loading = true;
    },
    setAllApplicantAccessidSuccess(state, action) {
      state.loading = false;
      state.accessData.allapplicant = action.payload.data;
    },
    setAllApplicantAccessidFailure(state) {
      state.loading = false;
      state.error = "AccessID error";
    },
    updateAllSourceNotes(state, action) {
      const { applicantId, newNoteUiid, note, addedBy, addedOn, uiid } =
        action.payload || {};
      const applicantLists = [
        Array.isArray(state.totalApplicantsData)
          ? state.totalApplicantsData
          : state.totalApplicantsData?.data,
        state.careerBuilder?.existingCandidates,
        state.monster?.existingCandidates,
      ];
      applicantLists.forEach((list) => {
        if (!Array.isArray(list)) return;
        list.forEach((applicant) => {
          if (String(applicant.uiid) !== String(applicantId)) return;
          applicant.notes ??= [];
          applicant.notesList ??= [];
          const noteExists = applicant.notes.some(
            (id) => String(id) === String(newNoteUiid),
          );
          if (!noteExists) {
            applicant.notes.push(newNoteUiid);
          }

          const listExists = applicant.notesList.some(
            (n) => String(n.uiid) === String(uiid),
          );
          if (!listExists) {
            applicant.notesList.unshift({
              uiid,
              note,
              addedBy,
              addedOn,
            });
            applicant.notesList.sort(
              (a, b) => new Date(b.addedOn) - new Date(a.addedOn),
            );
          }
        });
      });
    },
    updateAllSourceVisitHistory: (state, action) => {
      const { applicantId, visitHistory, addedBy, addedOn, uiid } =
        action.payload || {};
      const applicantLists = [
        Array.isArray(state.totalApplicantsData)
          ? state.totalApplicantsData
          : state.totalApplicantsData?.data,
        state.careerBuilder?.existingCandidates,
        state.monster?.existingCandidates,
      ];
      applicantLists.forEach((list) => {
        if (!Array.isArray(list)) return;
        list.forEach((applicant) => {
          if (String(applicant.uiid) !== String(applicantId)) return;
          applicant.visitHistory ??= [];
          applicant.visitHistoryList ??= [];
          const exists = applicant.visitHistoryList.some(
            (v) => String(v.uiid) === String(uiid),
          );
          if (!exists) {
            applicant.visitHistoryList.unshift({
              uiid,
              addedBy,
              addedOn,
            });
            applicant.visitHistoryList.sort(
              (a, b) => new Date(b.addedOn) - new Date(a.addedOn),
            );
            // Limit to 5 items
            if (applicant.visitHistoryList.length > 5) {
              applicant.visitHistoryList = applicant.visitHistoryList.slice(0, 5);
            }
          }
          const visitExists = applicant.visitHistory.some(
            (id) => String(id) === String(uiid),
          );

          if (!visitExists) {
            applicant.visitHistory.push(uiid);
          }
        });
      });
    },
    updateApplicantNotesList(state, action) {
      const { applicantId, notesList } = action.payload || {};
      if (!applicantId) return;
      const applicantIdStr = String(applicantId);
      const applicantLists = [
        Array.isArray(state.totalApplicantsData)
          ? state.totalApplicantsData
          : state.totalApplicantsData?.data,
        state.careerBuilder?.existingCandidates,
        state.monster?.existingCandidates,
      ];
      const safeNotes = Array.isArray(notesList) ? notesList : [];
      const noteIds = safeNotes
        .map((n) => (typeof n === "object" ? n?.uiid : n))
        .filter(Boolean);
      for (const list of applicantLists) {
        if (!Array.isArray(list)) continue;
        const applicant = list.find((a) => String(a?.uiid) === applicantIdStr);
        if (!applicant) continue;
        applicant.notes = [...new Set(noteIds)];
        applicant.notesList = Array.from(
          new Map(safeNotes.map((n) => [String(n.uiid || n._id), n])).values(),
        )
          .sort((a, b) => new Date(b.addedOn) - new Date(a.addedOn));
      }
    },
    updateApplicantVisitHistoryList(state, action) {
      const { applicantId, visitHistoryList } = action.payload || {};
      if (!applicantId) return;
      const applicantIdStr = String(applicantId);
      const applicantLists = [
        Array.isArray(state.totalApplicantsData)
          ? state.totalApplicantsData
          : state.totalApplicantsData?.data,
        state.careerBuilder?.existingCandidates,
        state.monster?.existingCandidates,
      ];
      const safeVisits = Array.isArray(visitHistoryList) ? visitHistoryList : [];
      const visitIds = safeVisits
        .map((v) => (typeof v === "object" ? v?.uiid : v))
        .filter(Boolean);
      for (const list of applicantLists) {
        if (!Array.isArray(list)) continue;
        const applicant = list.find((a) => String(a?.uiid) === applicantIdStr);
        if (!applicant) continue;
        const existingIds = Array.isArray(applicant.visitHistory)
          ? applicant.visitHistory
          : [];
        applicant.visitHistory = [...new Set([...existingIds, ...visitIds])];

        const existingVisits = Array.isArray(applicant.visitHistoryList) ? applicant.visitHistoryList : []
        const merged = [...existingVisits, ...safeVisits];
        applicant.visitHistoryList = Array.from(new Map(merged.map(v => [String(v.uiid), v])).values())
          .sort((a, b) => new Date(b.addedOn) - new Date(a.addedOn))
          .slice(0, 5);
      }
    },
    addNoteToApplicant(state, action) {
      const { applicantId, note, addedBy, addedOn, uiid } =
        action.payload || {};
      const applicantLists = [
        Array.isArray(state.totalApplicantsData)
          ? state.totalApplicantsData
          : state.totalApplicantsData?.data,
        state.careerBuilder?.existingCandidates,
        state.monster?.existingCandidates,
      ];
      applicantLists.forEach((list) => {
        if (!Array.isArray(list)) return;
        const applicant = list.find(
          (a) => String(a.uiid) === String(applicantId),
        );

        if (!applicant) return;
        applicant.notes ??= [];
        applicant.notesList ??= [];
        const noteExists = applicant.notes.some(
          (id) => String(id) === String(uiid),
        );

        if (!noteExists) {
          applicant.notes.push(uiid);
        }
        const exists = applicant.notesList.some(
          (n) => String(n.uiid) === String(uiid),
        );

        if (!exists) {
          applicant.notesList.unshift({
            uiid,
            note,
            addedBy,
            addedOn,
          });
          applicant.notesList.sort(
            (a, b) => new Date(b.addedOn) - new Date(a.addedOn),
          );
        }
      });
    },
    addVisitHistoryToApplicant: (state, action) => {
      const { applicantId, visitHistory, addedBy, addedOn, uiid } =
        action.payload || {};
      const applicantLists = [
        Array.isArray(state.totalApplicantsData)
          ? state.totalApplicantsData
          : state.totalApplicantsData?.data,
        state.careerBuilder?.existingCandidates,
        state.monster?.existingCandidates,
      ];
      applicantLists.forEach((list) => {
        if (!Array.isArray(list)) return;
        const applicant = list.find(
          (a) => String(a.uiid) === String(applicantId),
        );

        if (!applicant) return;
        applicant.visitHistory ??= [];
        applicant.visitHistoryList ??= [];
        const exists = applicant.visitHistoryList.some(
          (v) => String(v.uiid) === String(uiid),
        );
        if (!exists) {
          applicant.visitHistoryList.unshift({
            uiid,
            addedBy,
            addedOn,
          });
          applicant.visitHistoryList.sort(
            (a, b) => new Date(b.addedOn) - new Date(a.addedOn),
          );
          // Limit to 5 items
          if (applicant.visitHistoryList.length > 5) {
            applicant.visitHistoryList = applicant.visitHistoryList.slice(0, 5);
          }
        }
        const visitExists = applicant.visitHistory.some(
          (id) => String(id) === String(uiid),
        );

        if (!visitExists) {
          applicant.visitHistory.push(uiid);
        }
      });
    },
    updateExistingCandidates(state, action) {
      const { source, candidate } = action.payload;
      if (!["careerBuilder", "monster"].includes(source)) return;
      const target = state[source];
      if (!target) return;
      if (!Array.isArray(target.existingCandidates)) {
        target.existingCandidates = [];
      }
      const exists = target.existingCandidates.some(
        (c) => c.uiid === candidate.uiid,
      );
      if (!exists) {
        target.existingCandidates.push(candidate);
        const candidateResumeIds = candidate?.resumeIds?.map((r) => String(r.id)) || [];
        if (Array.isArray(target.fullResponse)) {
          target.fullResponse = target.fullResponse.map((item) => {
            if (candidateResumeIds.includes(String(item?.resumeId))) {
              return {
                ...item,
                uiid: candidate.uiid,
              };
            }
            return item;
          });
        }
      }
    },
    resetIntegratedSearch(state) {
      state.totalApplicantsCount = 0;
      state.totalApplicantsData = null;
      state.totalRecords = 0;

      state.careerBuilder = resetCareerMonster;
      state.monster = resetCareerMonster;
    },
    addApplicantToInternalDB(state, action) {
      const candidate = action.payload;

      if (!Array.isArray(state.totalApplicantsData)) {
        state.totalApplicantsData = [];
      }

      const exists = state.totalApplicantsData.some(
        (c) => c?.uiid === candidate?.uiid,
      );

      if (!exists) {
        state.totalApplicantsData.unshift(candidate);
        state.totalApplicantsCount += 1;
        state.totalRecords += 1;
      }
    },
  },
});

export const {
  // Loading
  setStateLoading,
  revertStateLoading,

  getAllApplicantsDataStart,
  getAllApplicantsDataSuccess,
  getAllApplicantsDataFailure,

  // Career Builder
  getCareerBuilderApplicantsDataStart,
  getCareerBuilderApplicantsDataSuccess,
  getCareerBuilderApplicantsDataFailure,
  updateCareerBuilderApplicantsDataStart,
  updateCareerBuilderApplicantsDataSuccess,
  updateCareerBuilderApplicantsDataFailure,

  // Monster
  getMonsterApplicantsDataStart,
  getMonsterApplicantsDataSuccess,
  getMonsterApplicantsDataFailure,
  updateMonsterApplicantsDataStart,
  updateMonsterApplicantsDataSuccess,
  updateMonsterApplicantsDataFailure,

  //Integrated Search
  getIntegratedSearchStart,
  fetchBulkResumesDataStart,
  fetchBulkResumesSuccess,
  fetchBulkResumesFailure,
  fetchCBBulkResumesDataStart,
  fetchCBBulkResumesSuccess,
  fetchCBBulkResumesFailure,
  setcareerBuilderAccessidStart,
  setcareerBuilderAccessidSuccess,
  setcareerBuilderAccessidFailure,
  setMonsterAccessidStart,
  setMonsterAccessidSuccess,
  setMonsterAccessidFailure,
  setAllApplicantAccessidStart,
  setAllApplicantAccessidSuccess,
  setAllApplicantAccessidFailure,
  updateAllSourceNotes,
  updateExistingCandidates,
  addApplicantToInternalDB,
  // Reset
  resetIntegratedSearch,

  updateApplicantNotesList,
  updateApplicantVisitHistoryList,
  addNoteToApplicant,
  updateAllSourceVisitHistory,
  addVisitHistoryToApplicant,
} = internalDbESSlice.actions;

export default internalDbESSlice.reducer;
